<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div id="account-config-container">
  <a class="returnbutton hide-gt-sm" color="primary" mat-raised-button routerLink="/">
    Return to D2ArmorPicker
  </a>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title> Account Configuration </mat-card-title>
      <mat-card-subtitle>
        The configuration on this page will not be reset when you reset your build settings.
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      This will come in a future update. Right now, I just wanted to push the "Debugging" section
      out.
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title> Debugging & Troubleshooting </mat-card-title>
      <mat-card-subtitle>
        Tools for debugging issues and generating diagnostic data.
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <!-- Data Export Section -->
      <div class="debug-section">
        <h4 class="debug-section-title">Diagnostic Data</h4>
        <p class="debug-section-description">
          Export diagnostic data files when requested by the support team for troubleshooting.
        </p>
        <div class="debug-button-group">
          <button
            (click)="downloadArmorInformation()"
            class="debug-btn"
            color="primary"
            mat-flat-button
            matTooltip="Download your armor data for analysis">
            Export Armor Data
            <span class="debug-btn-filename">(d2ap_armor.json)</span>
          </button>
          <button
            (click)="downloadManifestInformation()"
            class="debug-btn"
            color="primary"
            mat-flat-button
            matTooltip="Download manifest data for debugging">
            Export Manifest Data
            <span class="debug-btn-filename">(d2ap_manifest.json)</span>
          </button>
          <button
            (click)="downloadSystemInformation()"
            class="debug-btn"
            color="primary"
            mat-flat-button
            matTooltip="Download system information including localStorage keys and database table counts">
            Export System Info
            <span class="debug-btn-filename">(d2ap_system_info.json)</span>
          </button>
          <button
            *ngIf="isDevEnvironment"
            (click)="triggerFileInput()"
            class="debug-btn"
            color="warn"
            mat-flat-button
            matTooltip="Import and replace armor data from a d2ap_armor.json">
            Import Armor Data
          </button>
          <input
            #armorFileInput
            id="armorFileInput"
            type="file"
            accept=".json"
            (change)="importArmorData($event)"
            style="display: none" />
        </div>
      </div>

      <!-- Database Reset Section -->
      <div class="debug-section">
        <h4 class="debug-section-title">Database Management</h4>
        <p class="debug-section-description">
          Use these options if you experience database issues such as missing exotics or corrupted
          data.
        </p>
        <div class="debug-button-group">
          <button
            (click)="resetDatabase()"
            class="debug-btn"
            color="warn"
            mat-raised-button
            matTooltip="Clear local database cache - your settings will be preserved">
            Clear Database Cache
          </button>
        </div>
      </div>

      <!-- Full Reset Section -->
      <div class="debug-section">
        <h4 class="debug-section-title">Complete Reset</h4>
        <p class="debug-section-description danger-text">
          <strong>Warning:</strong> This will completely reset the application, removing all
          settings, builds, and data.
        </p>
        <div class="debug-button-group">
          <button
            (click)="resetEverything()"
            class="debug-btn"
            color="warn"
            mat-raised-button
            matTooltip="WARNING: This will delete everything and cannot be undone">
            Reset Application
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title> Privacy & Legal </mat-card-title>
      <mat-card-subtitle> Information about data handling and privacy. </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      Learn about how we handle your data and what information we collect:<br />
      <a
        class="btn-download"
        color="primary"
        mat-raised-button
        routerLink="/privacy-policy"
        target="_blank">
        View Privacy Policy
      </a>
      <br /><br />
      This application uses the Bungie.net API. Bungie's privacy policy also applies to data
      accessed through their API.
    </mat-card-content>
  </mat-card>

  <a class="returnbutton hide-gt-sm" color="primary" mat-raised-button routerLink="/">
    Return to D2ArmorPicker
  </a>
</div>
